import { IAppState } from '../../../AppModulesWrapper';

export const selectIsMobileLayout = (state: IAppState): boolean => {
  return state.servicePickerWidget.layout.adaptiveSettings.isMobile;
};
